import React from 'react';
import { Close as CloseIcon } from '@mui/icons-material';
import { colors } from '../../theme/index.js';
import Text from '../Text.js';
import { useTheme } from '@mui/material/styles';

/**
 * @param classes
 * @param title
 * @param paragraph
 * @param onClose
 * @param id
 * @param testid
 * @returns {*}
 * @constructor
 */
const InfoCard = ({
  classes,
  title,
  paragraph,
  onClose,
  id,
  testid,
  stillCallback
}) => {
  const theme = useTheme();
  const styles = {
    container: {
      backgroundColor: colors.surface,
      display: 'block',
      margin: '20px auto',
      padding: 10,
      position: 'relative',
      border: `2px solid ${theme.palette.primary.main}`,
      borderRadius: 7,
      maxWidth: '100%'
    },
    flexBlock: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    btnStyle: {
      width: 'fit-content'
    },
    closeIcon: {
      color: colors.mediumGrey,
      fontSize: 16,
      float: 'right',
      '&:hover': {
        cursor: 'pointer',
        color: colors.darkGrey
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...styles.container,
      ...styles.cardStyle
    },
    id: id || null
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    sx: styles.closeIcon,
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Text, {
    testid: testid,
    align: "left",
    medium: true,
    bold: true,
    display: "block",
    margin: "10px"
  }, title), /*#__PURE__*/React.createElement(Text, {
    align: "left",
    small: true,
    display: "block",
    margin: "10px"
  }, paragraph));
};
export default InfoCard;